import { getUrlWithId, useGetFetch } from '../utils/reactQuery';
import { ApiRoutesEnum } from '../utils/routes';

import { ReminderType } from './useGetAllReminders';

export type FetchRemindersResponseType = {
  count: number;
  results: ReminderType[];
};

export const useGetClientReminders = (id: string) => {
  return useGetFetch<FetchRemindersResponseType>({
    url: getUrlWithId(ApiRoutesEnum.getClient, id).concat('/reminders'),
    config: { enabled: !!id },
  });
};
